import api from "../../api.js";

export async function fetchTotalOutstandingToFollows(profileNo, branchcode) {
  const res = await api.get("/api/to-follows/total-outstanding", {
    params: {
      ...(profileNo != null ? { profileNo } : {}),
      ...(branchcode ? { branchcode } : {}),
    },
  });
  return res.data?.data || [];
}

export async function fetchProfilesWithOutstandingToFollows() {
  const res = await api.get("/api/to-follows/profiles-with-outstanding");
  return res.data?.data || [];
}

export async function markToFollowDispensed(id) {
  const res = await api.post(`/api/to-follows/${id}/dispense`);
  return res.data?.data || {};
}

